import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { MdEdit } from "react-icons/md";
import TableColumn from "../../../components/TableColumn/TableColumn";
import Skeleton from "../../../components/Skeleton/Skeleton";

const CurrentAdvertising = () => {
  const navigate = useNavigate();
  const sorts = ["Client", "Status"];
  const headings = [
    "Time",
    "Client",
    "Location",
    "Website",
    "About",
    "Status",
    "",
  ];
  const [events, setEvents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(
      Number(localStorage.getItem("ListCurrentPageCurrentAdvertising")) || 1
  );
  const records = 10;
  const [sortBy, setSortBy] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [loading, setLoading] = useState(false);

  const formatDate = (timestamp) => {
    if (!timestamp) return "N/A";
    const date = new Date(timestamp);
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return date.toLocaleString("en-US", options);
  };

  const fetchData = async (page, term) => {
    setLoading(true);
    try {
      const response = await api.get("/ads", {
        params: {
          page,
          name: term,
          sort_column: sortBy,
          sort: sortDirection,
        },
      });

      const now = new Date();

      const formattedEvents = response.data.data
          .map((item) => {
            const startDate = item.date_start ? new Date(item.date_start) : null;
            const endDate = item.date_end ? new Date(item.date_end) : null;

            return {
              Time:
                  startDate && endDate
                      ? `${formatDate(startDate)} - ${formatDate(endDate)}`
                      : "N/A",
              Client: item.business_name || item.venue_name || (
                  <span style={{ color: "red" }}>Client not informed</span>
              ),
              Location: item.location,
              Website: item.website,
              About: item.about,
              Status: item.status,
              _id: item._id,
              startDate,
              endDate,
            };
          })
          // keep only current, non-deleted ads
          .filter(
              (item) =>
                  item.Status !== "deleted" &&
                  item.startDate &&
                  item.endDate &&
                  now >= item.startDate &&
                  now <= item.endDate
          );

      setTotalPages(Math.ceil(response.data.total));
      setEvents(formattedEvents);
    } catch (error) {
      console.error(`Error fetching events: ${error}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage, searchTerm);
  }, [sortBy, sortDirection, currentPage, searchTerm]);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    localStorage.setItem("ListCurrentPageCurrentAdvertising", page);
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    setCurrentPage(1); // reset pagination on new search
  };

  const sortColumnsMapping = {
    Client: "business_name",
    Status: "status",
  };

  const handleSort = (columnName) => {
    const backendColumnName = sortColumnsMapping[columnName];
    if (sortBy === backendColumnName) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortBy(backendColumnName);
      setSortDirection("asc");
    }
  };

  const actions = [
    {
      label: <MdEdit size={30} color="#4F30EA" />,
      onClick: (rowData) => {
        navigate(`/ad-management/edit/${rowData._id}`);
      },
    },
  ];

  const fetchAllData = async () => {
    try {
      const response = await api.get("/ads", {
        params: { records: 100000 },
      });
      return response.data.data.map((item) => ({
        Client: item.business_name,
        Location: item.event_name,
        Website: item.website,
        About: item.about,
        Status: item.status,
        _id: item._id,
      }));
    } catch (error) {
      console.error(`Error fetching all data: ${error}`);
      return [];
    }
  };

  return (
      <section className="current-ads position-relative">
        <TableColumn
            hasHeader
            columns={headings}
            data={events}
            sortableColumns={sorts}
            hasExport
            hasSearch
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            records={records}
            actions={actions}
            inputSearchProps={{ value: searchTerm, onChange: handleChange }}
            fetchAllData={fetchAllData}
            onSort={handleSort}
            hasModifyHeader
            loading={loading}
        />
      </section>
  );
};

export default CurrentAdvertising;
